"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkedRecordDisplayFormats = void 0;
exports.linkedRecordDisplayFormats = [
    "standard",
    "expanded",
    "simplified",
    "compact",
    "table",
];
